import React from 'react'
import money_rounding from "../../utils/money_rounding";
import numberbeautify from "../../utils/numberbeautify";

const Remained_itemlist = ({items, total_6_to_9_months, total_more_than_9_months}) => {
  return (
    <div className='mt-6'>
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4 items-center">
            <div className='w-full bg-white rounded-lg px-5 py-8'>
                <p className='text-sm'>کۆی بەهای ئەو کاڵایانەی لە نێوان ٦ بۆ ۹ مانگ لە کۆگا ماونەتەوە</p>
                <p className='text-lg'>{numberbeautify(money_rounding(total_6_to_9_months))} $</p>
            </div>
            <div className='w-full bg-yellow-200 rounded-lg px-5 py-8'>
                <p className='text-sm'>کۆی بەهای ئەو کاڵایانەی لە  ۹ مانگ زیادتر کۆگا ماونەتەوە</p>
                <p className='text-lg'>{numberbeautify(money_rounding(total_more_than_9_months))} $</p>
            </div>
        </div>
        {/* Category List Card */}
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto mt-6">
            
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">لیستی کاتیگۆری</h2>
            </div>

            {/* Table */}
            <table className="w-full">
            <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ناوی کاڵا</th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">کۆد</th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">بڕی ماوە</th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ماوەی مانەوە لە کۆگا</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
                {items?.map((lis) => (
                <tr key={lis.item_id} className={`${lis.days_in_stock>273?'bg-yellow-200':'bg-white'} transition-colors duration-100`}>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.item_name}
                    </td>
                    <td className="px-6 py-4 text-sm text-slate-500 text-right">
                        {lis.item_barcode}
                    </td>
                    <td className="px-6 py-4 text-sm text-slate-500 text-right">
                        {lis.item_unit_one} {Math.floor(lis.item_qty/lis.item_unit_one_of_many)}/{money_rounding(Number(lis.item_qty) % lis.item_unit_one_of_many)} {lis.item_unit_many}
                    </td>
                    <td className="px-6 py-4 text-sm text-slate-500 text-right">
                        {`${Math.floor(lis.days_in_stock / 30)} مانگ - (${lis.days_in_stock} ڕۆژ)`}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
    </div>
  )
}

export default Remained_itemlist